import { render, staticRenderFns } from "./ship_company_carTeams_page.vue?vue&type=template&id=55e20854&scoped=true"
import script from "./ship_company_carTeams_page.vue?vue&type=script&lang=js"
export * from "./ship_company_carTeams_page.vue?vue&type=script&lang=js"
import style0 from "./ship_company_carTeams_page.vue?vue&type=style&index=0&id=55e20854&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e20854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e20854')) {
      api.createRecord('55e20854', component.options)
    } else {
      api.reload('55e20854', component.options)
    }
    module.hot.accept("./ship_company_carTeams_page.vue?vue&type=template&id=55e20854&scoped=true", function () {
      api.rerender('55e20854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/ship_company/ship_company_carTeams_page.vue"
export default component.exports